import { Badge } from '@/components/shadcn/badge'
import { IconPaperclipOutline } from '@icons/IconPaperclipOutline'
import { MessagesStorageStorageDetailItem } from './TemplatesFilesList'

// Simple file card component
export const FileCard = ({ file, actions }: { file: MessagesStorageStorageDetailItem; actions: React.ReactNode }) => {
  const { filename, blobName } = file
  return (
    <div className="flex items-center justify-between rounded-lg border bg-background pl-3">
      <div className="flex items-start gap-5">
        <IconPaperclipOutline className="size-7 shrink-0 text-muted-foreground" />
        <div className="flex flex-col gap-2 text-sm">
          <span className="font-medium">{filename}</span>
          <Badge variant="secondary">{blobName}</Badge>
        </div>
      </div>
      <div className="flex shrink-0 flex-col gap-2">{actions}</div>
    </div>
  )
}
